import { A11y, Swiper, SwiperClass } from '@common/carousel/swiper';

import { ShortClipModel } from '../utils/types';

export interface ShortClipCardCarouselProps {
  onActiveIndexChange: (swiper: SwiperClass) => void;
  items: Array<ShortClipModel>;
  renderItem: (item: ShortClipModel, index: number) => React.ReactNode;
}

export function ShortClipCardCarousel({ onActiveIndexChange, items, renderItem }: ShortClipCardCarouselProps) {
  return (
    <Swiper
      breakpoints={{
        0: {
          slidesPerView: 1.05,
          spaceBetween: 8,
        },
        740: {
          slidesPerView: 1.4,
          spaceBetween: 8,
        },
      }}
      modules={[A11y]}
      aria-label='숏클립 캐러셀'
      role='region'
      aria-roledescription='carousel'
      threshold={20}
      onActiveIndexChange={onActiveIndexChange}
      a11y={{
        prevSlideMessage: '이전 영상입니다.',
        nextSlideMessage: '다음 영상입니다.',
        firstSlideMessage: '첫번째 영상입니다',
        lastSlideMessage: '마지막 영상입니다.',
      }}
    >
      {items.map(renderItem)}
    </Swiper>
  );
}
